import { FC } from 'react'
import { Avatar } from 'components/features/socialFeed/Avatar/Avatar'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { memberFeedInfoSelector } from 'selectors/feedSelectors'
import { feedMemberAvatarSelector } from 'selectors/feedImagesSelectors'

type MemberAvatarProps = {}

export const MemberAvatar: FC<MemberAvatarProps> = () => {
  const member = useStoreSelector(memberFeedInfoSelector)
  const avatar = useStoreSelector(feedMemberAvatarSelector)

  return (
    <Avatar
      matchRatio={ null }
      isOwn
      name={ member ? member.username : null }
      avatar={ avatar }
    />
  )
}
